import moment from "moment";
import React, { useState } from "react";

import { endpoint } from "../../../common/constant";
import ALoader from "../../../common/a-loader";
import { fetchAllPostPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";

import SingleStudentSearchCard from "../commonComponents/SingleStudentSearchCard";
import ManageReceiptsWrapper from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/";

const CentralizedManageReceipts = () => {
  const [receipts, setReceipts] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const searchHandler = async (searchCriteria) => {
    setLoading(true);

    const studentDetailsResponse = await fetchAllPostPromisedData(
      `${endpoint.getStudentChargesList}?offset=0`,
      searchCriteria
    );

    setLoading(false);
    if (
      studentDetailsResponse.data
        ?.studentApplicationDetailsSearchResponseDTOList.length
    )
      try {
        setLoading(true);
        const payload = {
          ...searchCriteria,
          // businessAreaList:,
          startDate: new Date(
            moment()?.subtract(7, "day").startOf("day")
          ).toISOString(),
          endDate: new Date(moment().endOf("day")).toISOString(),
        };

        //  integrate MR API
        const resp = await fetchAllPostPromisedData(
          `${endpoint.manageReceipts.search}?offset=0`,
          payload,
          "post"
        );

        if (resp?.code === 200) {
          setReceipts(resp?.data?.receiptsResponseDTOList);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }

    return;
  };

  const crossHandler = () => setReceipts([]);

  return (
    <div>
      {isLoading && <ALoader position="fixed" />}

      <SingleStudentSearchCard
        heading="Manage Receipts"
        searchHandler={searchHandler}
        crossHandler={crossHandler}
      />

      <ManageReceiptsWrapper centralizedRowsData={receipts} />
    </div>
  );
};

export default CentralizedManageReceipts;
